<template lang="html">
<v-container>

    <u-animate-container>
      <u-animate name="bounceInRight" delay="0s" duration="2s" :iteration="1" :offset="0" animateClass="animated" :begin="false">
        <v-flex xs12>
            <v-container>
              <v-layout row wrap>
                <v-flex  xs12 pa-1>
                  <statscard color="green" icon="mdi-account" title="Mis Facturas" :value="total.toString()" sub-icon="mdi-file-document" sub-text="" />
                </v-flex>
              </v-layout>
            </v-container>
        </v-flex>
      </u-animate>
    </u-animate-container>

  <v-layout row>
    <v-flex xs12>
      <v-card class>
        <v-card-title primary-title class="grey lighten-4">
          <v-tooltip top>
                  <v-btn
                        slot="activator"
                        dark
                        @click.stop="helpdialog = true"
                        icon class="mx-0">
                     <v-icon color="red">help</v-icon>
                 </v-btn>
             <span>Mis Facturas</span>
          </v-tooltip>
          <h3 class="headline mb-0">Mis Facturas</h3>
          <v-spacer></v-spacer>
          <!-- <v-btn color="primary" dark class="mb-2" @click="nuevoUsuario">Agregar</v-btn> -->
        </v-card-title>
          <v-card-title primary-title class="grey lighten-4">
            <v-spacer></v-spacer>
            <v-text-field
              :loading="loading"
              v-model="search"
              label="Buscar"
              single-line
              hide-details
              :append-outer-icon="loading ? 'update' : 'search'"
              @change="searchFilterConciliacion"
            ></v-text-field>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="padding: 0">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="conciliaciones"
                rows-per-page-text="Filas por Pág"
                :pagination.sync="pagination"
                :total-items="total"
                :rows-per-page-items="rowsPerPageItems"
                row
                wrap
                pl-0
                ml-0
                pr-0
                mr-0
                class="elevation-0"
             >
               <template slot="items" slot-scope="props">

                 <td align="center">{{ props.item.unionize == null || props.item.unionize.cpc == null ? 'N/A' : props.item.unionize.cpc }}</td>
                 <td align="center">{{ props.item.rif }} </td>
                 <td align="center">{{ props.item.razon_social }}</td>
                 <!-- <td>{{ props.item.payments[0].way_to_pay }}</td> -->
                 <td align="center">
                     <v-chip color="green" text-color="white">PAGADO</v-chip>
                 </td>
                 <td>{{ props.item.id ? '#' + props.item.id : '' }}</td>
                 <td>{{ props.item.created_at ? props.item.created_at : '' }}</td>
                 <td align="center">{{ new Intl.NumberFormat("de-DE").format(props.item.amount) }}</td>

                 <td class="justify-center layout px-0">
                    <v-tooltip top>
                        <v-btn @click="printFactura(props.item)" slot="activator" icon class="mx-0" >
                            <v-icon color="primary">web</v-icon>
                        </v-btn>
                        <span>Visualizar Factura</span>
                    </v-tooltip>
                </td>
               </template>
               <v-alert slot="no-results" :value="true" color="error" icon="warning">
                 La busqueda para  "{{ search }}" No resultó.
               </v-alert>
             </v-data-table>

          </v-card-text>
      </v-card>
    </v-flex>

    <!-- loading -->
    <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
    >
        <v-card
            color="primary"
            dark
        >
            <v-card-text>
            Porfavor Espere...
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- Inicio de dialogo de ayuda -->
    <v-dialog
          v-model="helpdialog"
          max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Conciliación de pagos</v-card-title>

            <v-card-text>


              Sección para acentar en el sistema que se ha recibido el pago correspondiente a la actuación profesional registrada.

            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                flat="flat"
                @click="helpdialog = false"
              >
                Salir
              </v-btn>

            </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Fin de dialogo -->

        <v-layout row justify-center>
            <v-dialog v-model="print" persistent max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Factura</span>
                    </v-card-title>
                    <v-card-text>
                        <FacturaPagoCuentaCobrar :loading="loading" :data="dataFactura" v-if="print && dataFactura.status == 'SOLV-PAGADO'" v-on:responseLoading="loading = $event"/>
                        <FacturaPagoConciliacion :data="dataFactura" v-if="print && dataFactura.status == 'PAGADO'"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary darken-1" @click="print = false">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loading" color="primary darken-1" flat v-print="'#printMe'">Imprimir Factura</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

  </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import { mapGetters } from 'vuex'
import FacturaPagoCuentaCobrar from '~/components/factura/FacturaPagoCuentaCobrar.vue'
import FacturaPagoConciliacion from '~/components/factura/FacturaPagoConciliacion.vue'
import { UAnimateContainer, UAnimate } from 'vue-wow'
import statscard from '~/components/material/StatsCard.vue'

export default {

    name: 'cuentas-por-cobrar-view',

    components: {
        UAnimateContainer,
        UAnimate,
        statscard,
        FacturaPagoCuentaCobrar,
        FacturaPagoConciliacion
    },

    computed: {
        ...mapGetters({
            authenticated: 'authCheck'
        }),
        getInvoice () {
            return this.editItem
        },
    },

    watch: {
        pagination() {
            this.getConciliacionByPagination();
        }
    },

    data () {
        return {
            print: false,
            valid: false,
            dialog: false,
            dialogAnulacion: false,
            formAnulacion: new Form({
              id: '',
              motivo_anulacion: '',
            }),
            helpdialog: false,
            dialogEdit: false,
            conciliaciones: [],
            activePagination: false,
            total: 0,
            dataFactura: {},
            pagination: {},
            loading: false,
            tipo: '',
            search: '',
            editItem: {},
            headers: [
            { text: 'CPC', sortable: false, align: 'center' },
                { text: 'RIF', value: 'rif', sortable: false, align: 'center' },
                { text: 'RAZON SOCIAL', value: 'razon_social', sortable: false, align: 'center' },
                // { text: 'METODO DE PAGO', value: 'way_to_pay', sortable: false },
                { text: 'ESTATUS', value: 'status', sortable: false, align: 'center' },
                { text: 'NUMERACION', value: 'number', sortable: false, align: 'center' },
                { text: 'FECHA', value: 'created_at', sortable: false, align: 'center' },
                { text: 'MONTO', value: 'amount', sortable: false, align: 'center' },
                { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' }
            ],
            rowsPerPageItems: [10, 20, 50, 100],
        }
    },

    methods: {

        async getConciliacionByPagination () {
            this.loading = true;
            if (this.search) {
                await axios.get(`/api/cliente/facturas-filter?query=${this.search}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.conciliaciones = res.data.data;
                        this.total = res.data.total;
                    })
                    .catch(e => {
                        console.log(e.response)
                    })
                    .finally(() => this.loading = false);
            }
            if (this.pagination.sortBy && !this.search) {
                const direction = this.pagination.descending ? 'desc' : 'asc';
                await axios.get(`/api/cliente/facturas-order?direction=${direction}&sortBy=${this.pagination.sortBy}&page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.conciliaciones = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
            if(!this.search && !this.pagination.sortBy) {
                await axios.get(`/api/cliente/facturas?page=${this.pagination.page}&per_page=${this.pagination.rowsPerPage}`)
                    .then(res => {
                        this.conciliaciones = res.data.data;
                        this.total = res.data.total;
                    })
                    .finally(() => this.loading = false);
            }
        },

        searchFilterConciliacion () {
            this.getConciliacionByPagination()
        },

        editarConciliacion (props) {
            this.editItem = props.item
            this.dialogEdit = true
        },

        closeDialogInvoiceEdit(response) {
            if (response != null) {
                this.getConciliacionByPagination();
            }
            this.dialogEdit = false
        },

        cerrarDialogAnular () {
            this.dialogAnulacion = false
            this.$nextTick(() => {
                this.$refs.formanular.resetValidation()
                this.formAnulacion.motivo_anulacion = ''
                this.loading = false
            })
        },

        async printFactura(item) {
          console.log(item)
          this.dataFactura = item
          this.print = true
        }

    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/cliente/MisFacturas.vue